import { convertDateTime } from 'utils/helpers';

import { normalizeFilters } from '../models/filters';

import { convertToCurrency, convertNumberBR, convertDate } from 'xpi-black-ui/Utils/helpers';

import uuidv4 from 'uuidv4';

export const colorStatus = statusId => ({
  1: '#3597db',
  2: '#1a7449',
  3: '#cf4242',
  520: '#cf4242',
  9: '#cf4242',
  4: '#d07a7a',
  5: '#a15c45',
  6: '#db805f',
}[statusId] || '#3597db');

export const normalizeProposals = proposals => (
  proposals.map((proposal) => {
    return {
      ...proposal,
      id: uuidv4(),
      comissaoNumerico: proposal.comissao,
      vencimento: convertDate(proposal.vencimento),
      comissao: convertToCurrency(proposal.comissao),
      precoFinal: convertToCurrency(proposal.precoFinal),
      quantidade: convertNumberBR(proposal.quantidade, 2),
      dataInclusao: convertDateTime(proposal.dataInclusao),
      precoReferencia: convertToCurrency(proposal.precoReferencia),
      status: {
        ...proposal.status,
        color: proposal.status
          ? colorStatus(proposal.status.id)
          : '',
      },
    };
  })
);

export const filtersTypes = [
  { name: 'status', title: 'Status da Proposta', placeholder: 'Status' },
  { name: 'listaDataContratacao', title: 'Data de Envio' },
  { name: 'clientes', title: 'Clientes' },
  { name: 'estruturas', title: 'Estruturas' },
  { name: 'ativos', title: 'Ações' },
  { name: 'vencimentos', title: 'Encerramentos' },
];

export const normalizeProposalsFilters = filters => (
  normalizeFilters({
    ...filters,
    status: filters.status.filter(status => status),
    vencimentos: filters.vencimentos.map(vencimento => ({
      id: vencimento,
      nome: convertDate(vencimento),
    })),
    listaDataContratacao: filters.listaDataContratacao.map(date => ({
      id: date,
      nome: convertDate(date),
    })),
    clientes: filters.clientes.map(cliente => ({
      id: cliente.toString(),
      nome: cliente.toString(),
    })),
  }, filtersTypes)
);
